import React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

const RecentItemsList = ({ items }) => {
  if (!items || items.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" align="center">
        No items found
      </Typography>
    );
  }

  return (
    <List dense>
      {items.map((item) => (
        <ListItem key={item.id}>
          <ListItemText
            primary={`${item.id} - ${item.name}`}
            secondary={`Type: ${item.type}`}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default RecentItemsList;
